import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from "@angular/core";
import { ReportSummaryPayload } from "src/app/models/reports";

@Component({
    selector: 'mwp-report-builder-summary',
    templateUrl: './report-builder-summary.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ReportBuilderSummaryComponent implements OnInit {
    @Input() public reportSummaryPayload: ReportSummaryPayload;

    @Output() public emitCancel: EventEmitter<any> = new EventEmitter();
    @Output() public emitSave: EventEmitter<any> = new EventEmitter<any>();



    public fileTypeCheckboxSelect: string = 'selected';
    public fileExportType: string = 'fileExportType';

    public fileTypeFormArrayName: string = 'fileTypeFormArrayName';
    public dateWizardValue: string = 'dateWizardValue';

    constructor(
    ) {
    }

    ngOnInit(): void {
    }

    public cancel(): void {
        this.emitCancel.emit();
    }

    public save(): void {
        this.emitSave.emit();
    }

}
